import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'upsc-truncated-paragraph',
  templateUrl: './truncated-paragraph.component.html',
  styleUrls: ['./truncated-paragraph.component.scss'],
})
export class TruncatedParagraphComponent implements OnInit, AfterViewInit {
  @Input() text: string;
  @Input() characterCountLimit = 500;
  @Input() lineCountLimit = 4;

  @ViewChild('paragraph', { static: true }) public paragraph: ElementRef;
  @ViewChild('paragraphText', { static: true }) public paragraphText: ElementRef;

  public isTruncated = false;
  public isLengthExceedLimit = false;
  public truncatedText;

  private fontSizePx = 13;
  private fontConstant = 2.19;
  private lineHeight = 1.77;
  private expectedMessageHeight = 0;

  constructor() {
  }

  public ngOnInit() {
    this.truncatedText = this.text;
  }

  public ngAfterViewInit() {
    this.adjustMessage();
  }

  private adjustMessage() {
    if (!this.paragraph || !this.paragraphText) {
      return;
    }

    this.isLengthExceedLimit = this.isRequireTruncate();
    this.isTruncated = this.isLengthExceedLimit;
    this.truncateText();
  }

  private isRequireTruncate(): boolean {
    const isExceedCharacterLimit = this.text.length > this.characterCountLimit;
    if (!isExceedCharacterLimit) {
      return true;
    }

    this.expectedMessageHeight = this.fontSizePx * this.lineHeight * this.lineCountLimit;
    this.paragraph.nativeElement.style.height = `${Math.ceil(this.expectedMessageHeight)}px`;

    const textOffsetHeight = this.paragraphText.nativeElement.offsetHeight;
    return textOffsetHeight > this.expectedMessageHeight;
  }

  private truncateText() {
    if (!this.isTruncated) {
      this.truncatedText = this.text;
      return;
    }

    const textOffsetWidth = this.paragraphText.nativeElement.offsetWidth;
    const charactersPerLine = textOffsetWidth * this.fontConstant / this.fontSizePx;
    const lineBasedCharacterCount = Math.floor(charactersPerLine * (this.lineCountLimit - 1) + (charactersPerLine / 2));
    const expectedCharacterCount = _.min([lineBasedCharacterCount, this.characterCountLimit]);
    this.truncatedText = this.text.substring(0, expectedCharacterCount);
  }

  public toggleText(event) {
    if (event) {
      event.preventDefault();
    }

    this.isTruncated = !this.isTruncated;
    this.truncateText();
  }
}
